import { useApp } from "@/context/AppContext";

export const Marquee = () => {
  const { content, t } = useApp();
  const items = content.marquee_items || [];

  return (
    <div className="bg-[#1E3A2B] py-5 overflow-hidden border-y border-[#E5B869]/20" data-testid="marquee-section">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
            {items.map((it, i) => (
              <span key={i} className="flex items-center">
                <span className="font-serif italic text-xl sm:text-2xl text-[#FAF7F2] px-7">{t(it)}</span>
                <span className="text-[#D96B27] text-sm">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
